import React, { useEffect, useState } from "react";
import "./OptiesTab.css";
import Text from "src/components/Text/Text";
import OptionContainerSelect from "src/components/Tabs/OptiesTab/components/OptionContainerSelect";
import OptionContainerChoose from "src/components/Tabs/OptiesTab/components/OptionContainerChoose";
import OptionContainerInterchangeable from "src/components/Tabs/OptiesTab/components/OptionContainerInterchangeable";
import { useConfiguration } from "src/contexts/ConfigurationContext";
// @ts-ignore
import isEqual from "lodash/isEqual";
import RadioBlocks from "src/components/Input/RadioBlocks/RadioBlocks";
import SimpleNumber from "src/components/Input/SimpleNumber/SimpleNumber";
import OptionNumber from "src/components/Input/Option/OptionNumber";
import Option from "src/components/Input/Option/Option";
import SelectUnselectExtended from "src/components/Input/SelectUnselectExtended/SelectUnselectExtended";
import { OptionsMaterial } from "src/types/configuration";
import RadioBlocksExtended from "src/components/Input/RadioBlocksExtended/RadioBlocksExtended";

const OptiesTab: React.FC = () => {
  const { state, setOptionsMaterial, setGutter, calculation } =
    useConfiguration();
  const [showTrimComponent, setShowTrimComponent] = useState(false);
  const [showRemmersComponent, setShowRemmersComponent] = useState(false);
  const [showPoerComponent, setShowPoerComponent] = useState(false);

  const handleZwart = (quantity: number) => {
    const updatedOptions = {
      ...state.optionsMaterial,
      liter_beits_zwart: quantity,
    };
    if (isEqual(updatedOptions, state.optionsMaterial)) return;
    setOptionsMaterial(updatedOptions);
  };

  const handleWit = (quantity: number) => {
    const updatedOptions = {
      ...state.optionsMaterial,
      liter_beits_wit: quantity,
    };
    if (isEqual(updatedOptions, state.optionsMaterial)) return;
    setOptionsMaterial(updatedOptions);
  };

  const handleGray = (quantity: number) => {
    const updatedOptions = {
      ...state.optionsMaterial,
      liter_beits_gray: quantity,
    };
    if (isEqual(updatedOptions, state.optionsMaterial)) return;
    setOptionsMaterial(updatedOptions);
  };

  const handleDouglas = (quantity: number) => {
    const updatedOptions = {
      ...state.optionsMaterial,
      liter_beits_douglas: quantity,
    };
    if (isEqual(updatedOptions, state.optionsMaterial)) return;
    setOptionsMaterial(updatedOptions);
  };

  const handlePoerChange = (poer: string, quantity: number) => {
    if (
      (poer === state.optionsMaterial.poer && quantity === 0) ||
      quantity === 0
    ) {
      poer = "empty";
    }

    // if (poer !== state.optionsMaterial.poer && quantity === 0) {
    //   quantity = 1;
    // }

    const updatedOptions = {
      ...state.optionsMaterial,
      poer: poer,
      poerQuantity: quantity,
    };

    if (isEqual(updatedOptions, state.optionsMaterial)) return;
    setOptionsMaterial(updatedOptions);
  };

  const handleTrimChange = (value: string) => {
    const updatedOptions = {
      ...state.optionsMaterial,
      daktrim_blank: value === "daktrim_blank",
      daktrim_zwart: value === "daktrim_zwart",
    };
    if (isEqual(updatedOptions, state.optionsMaterial)) return;
    setOptionsMaterial(updatedOptions);
  };

  const handleMontageToggle = (value: boolean) => {
    const updatedOptions = {
      ...state.optionsMaterial,
      montage: value,
    };

    if (isEqual(updatedOptions, state.optionsMaterial)) return;
    setOptionsMaterial(updatedOptions);
  };

  const handleHemelwaterafvoerToggle = (value: boolean) => {
    const updatedOptions = {
      ...state.optionsMaterial,
      hemelwaterafvoer_pvc: value,
    };
    if (isEqual(updatedOptions, state.optionsMaterial)) return;
    setOptionsMaterial(updatedOptions);
  };

  const handleBetonbandChange = (quantity: number) => {
    const updatedOptions = {
      ...state.optionsMaterial,
      betonband_antraciet: quantity,
    };
    if (isEqual(updatedOptions, state.optionsMaterial)) return;
    setOptionsMaterial(updatedOptions);
  };

  const handleGutterEnable = (value: boolean) => {
    const gutter = { ...state.gutter, enabled: value };

    if (isEqual(state.gutter, gutter)) return;
    setGutter(gutter);
  };

  const poerData = [
    {
      id: 1,
      name: "Betonpoer 15x15x60cm",
      imageUrl: "./images/poer.png",
      color: "",
      value: "poer",
      price: calculation.getPoer(),
      description: "",
      layout: "in_value",
      component: (
        <SimpleNumber
          value={
            state.optionsMaterial.poer === "poer"
              ? state.optionsMaterial.poerQuantity
              : 0
          }
          onChange={(value) => handlePoerChange("poer", value)}
          min={0}
          max={1000}
          step={1}
        />
      ),
    },
    {
      id: 2,
      name: "Poertegel 18x18x10cm",
      imageUrl: "./images/poertegel.png",
      color: "",
      value: "poertegel",
      price: calculation.getPoertegel(),
      description: "",
      layout: "in_value",
      component: (
        <SimpleNumber
          value={
            state.optionsMaterial.poer === "poertegel"
              ? state.optionsMaterial.poerQuantity
              : 0
          }
          onChange={(value) => handlePoerChange("poertegel", value)}
          min={0}
          max={1000}
          step={1}
        />
      ),
    },
  ];

  const trimData = [
    {
      id: 1,
      name: "Daktrim blank",
      imageUrl: "./images/daktrim.png",
      color: "",
      value: "daktrim_blank",
      price: calculation.getAluminiumTrim(),
      description: "",
    },
    {
      id: 2,
      name: "Daktrim zwart",
      imageUrl: "./images/daktrim-zwart.png",
      color: "",
      value: "daktrim_zwart",
      price: calculation.getBlackTrim(),
      description: "",
    },
  ];

  const remmers = [
    {
      name: "Remmers beits zwart 9005",
      value: "liter_beits_zwart",
      price: calculation.getLiterBeitsZwart(),
      quantity: state.optionsMaterial.liter_beits_zwart,
      imageUrl: "./images/liter.png",
      // description:
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      onChange: handleZwart,
    },
    {
      name: "Remmers beits wit 9010",
      value: "liter_beits_wit",
      price: calculation.getLiterBeitsWit(),
      quantity: state.optionsMaterial.liter_beits_wit,
      imageUrl: "./images/liter.png",
      // description:
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      onChange: handleWit,
    },
    {
      name: "Remmers beits grafietgrijs",
      value: "liter_beits_gray",
      price: calculation.getLiterBeitsGray(),
      quantity: state.optionsMaterial.liter_beits_gray,
      imageUrl: "./images/liter.png",
      // description:
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      onChange: handleGray,
    },
    {
      name: "Remmers beits douglas",
      value: "liter_beits_douglas",
      price: calculation.getLiterBeitsDouglas(),
      quantity: state.optionsMaterial.liter_beits_douglas,
      imageUrl: "./images/liter.png",
      // description:
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      onChange: handleDouglas,
    },
  ];

  return (
    <div className="opties-tab">
      <SelectUnselectExtended
        name={"Remmers beits"}
        imageUrl={"./images/liter.png"}
        description={
          "Remmers beits is geschikt om Douglas-hout buiten te beschermen tegen UV-vergrijzing, vocht, schimmel en weersinvloeden en houdt het hout langer mooi."
        }
        isSelected={
          state.optionsMaterial.liter_beits_zwart > 0 ||
          state.optionsMaterial.liter_beits_wit > 0 ||
          state.optionsMaterial.liter_beits_gray > 0 ||
          state.optionsMaterial.liter_beits_douglas > 0
        }
        selectedNames={remmers
          .filter(
            (remmer) =>
              (state.optionsMaterial[
                remmer.value as keyof typeof state.optionsMaterial
              ] as number) > 0
          )
          .map(
            (remmer) =>
              `${remmer.name.replace(/^Remmers beits\s*/i, "")} x ${state.optionsMaterial[
              remmer.value as keyof typeof state.optionsMaterial
              ] as number
              }`
          )
          .join(", ")}
        onSelect={() => true}
        onUnselect={() => false}
        showComponent={showRemmersComponent}
        onShowComponentToggle={setShowRemmersComponent}
        Component={() => (
          <>
            {remmers.map((remmer) => (
              <OptionNumber
                key={remmer.value}
                name={remmer.name}
                image={remmer.imageUrl}
                description={""}
                value={
                  state.optionsMaterial[
                  remmer.value as keyof typeof state.optionsMaterial
                  ] as number
                }
                price={remmer.price}
                onChange={(value) => remmer.onChange(value)}
              />
            ))}
            {/* <OptionNumber
              name={"Remmers beits zwart 9005"}
              image={"./images/liter.png"}
              description={""}
              value={state.optionsMaterial.liter_beits_zwart}
              price={calculation.getLiterBeitsZwart()}
              onChange={handleZwart}
            />
            <OptionNumber
              name={"Remmers beits wit 9010"}
              image={"./images/liter.png"}
              description={""}
              value={state.optionsMaterial.liter_beits_wit}
              price={calculation.getLiterBeitsWit()}
              onChange={handleWit}
            />
            <OptionNumber
              name={"Remmers beits grafietgrijs"}
              image={"./images/liter.png"}
              description={""}
              value={state.optionsMaterial.liter_beits_gray}
              price={calculation.getLiterBeitsGray()}
              onChange={handleGray}
            />
            <OptionNumber
              name={"Remmers beits douglas"}
              image={"./images/liter.png"}
              description={""}
              value={state.optionsMaterial.liter_beits_douglas}
              price={calculation.getLiterBeitsDouglas()}
              onChange={handleDouglas}
            /> */}
          </>
        )}
      />

      <SelectUnselectExtended
        name={"Poer"}
        imageUrl={"./images/poer.png"}
        description={
          "Betonpoeren zorgen voor een stabiele en duurzame fundering en voorkomt direct contact van het hout met de grond, waardoor opstijgend vocht en houtrot worden beperkt en de levensduur van de constructie wordt verlengd."
        }
        isSelected={state.optionsMaterial.poer !== "empty"}
        onSelect={() => true}
        onUnselect={() => false}
        selectedNames={
          (poerData.find((item) => item.value === state.optionsMaterial.poer)
            ?.name || "") + ` x ${state.optionsMaterial.poerQuantity}`
        }
        showComponent={showPoerComponent}
        onShowComponentToggle={setShowPoerComponent}
        Component={() => (
          <>
            {poerData.map((item) => (
              <OptionNumber
                key={item.value}
                name={item.name}
                image={item.imageUrl}
                description={item.description}
                value={
                  state.optionsMaterial.poer === item.value
                    ? state.optionsMaterial.poerQuantity
                    : 0
                }
                price={item.price}
                onChange={(value) => handlePoerChange(item.value, value)}
              />
            ))}
          </>
        )}
      />

      {state.roofType === "kapschuur" && (
        <SelectUnselectExtended
          name={"Dakgoot toevoegen"}
          imageUrl={"./images/dakgoot_zink.png"}
          description={""}
          isSelected={state.gutter.enabled}
          onSelect={() => handleGutterEnable(true)}
          onUnselect={() => handleGutterEnable(false)}
          price={calculation.getGutterPrice()}
        />
      )}
      {state.roofType === "platdak" && (
        <SelectUnselectExtended
          name={"Daktrim"}
          imageUrl={"./images/daktrim.png"}
          description={""}
          isSelected={
            state.optionsMaterial.daktrim_blank ||
            state.optionsMaterial.daktrim_zwart
          }
          onSelect={() => true}
          onUnselect={() => false}
          showComponent={showTrimComponent}
          onShowComponentToggle={setShowTrimComponent}
          selectedNames={`${trimData.find(
            (item) =>
              item.value ===
              (state.optionsMaterial.daktrim_blank
                ? "daktrim_blank"
                : "daktrim_zwart")
          )?.name || ""
            }`}
          Component={() => (
            <RadioBlocksExtended
              blocks={trimData}
              className={"daktrim-select"}
              showCheckbox
              value={
                state.optionsMaterial.daktrim_blank
                  ? "daktrim_blank"
                  : "daktrim_zwart"
              }
              onChange={handleTrimChange}
            />
          )}
        />
      )}

      {state.roofType === "platdak" && (
        <SelectUnselectExtended
          name={"HWA afvoer incl. pijp."}
          // no3d
          imageUrl={"./images/HWA_afvoerset.jpg"}
          description={"PVC Hemelwaterafvoer met bevestigingsmaterialen"}
          isSelected={state.optionsMaterial.hemelwaterafvoer_pvc}
          onSelect={() => handleHemelwaterafvoerToggle(true)}
          onUnselect={() => handleHemelwaterafvoerToggle(false)}
          // price={calculation.getHemelwaterafvoerPvc()}
          // selectedNames={
          //   state.optionsMaterial.hemelwaterafvoer_pvc
          //     ? `${Math.ceil(state.dimensions.width / 1000) * 2} m`
          //     : ""
          // }
          price={calculation.getHemelwaterafvoerPvc()}
        />
      )}

      <OptionNumber
        name={"Betonband antraciet 6x20x100cm"}
        image={"./images/betonband.jpg"}
        description={""}
        value={state.optionsMaterial.betonband_antraciet}
        price={calculation.getBetonbandAntraciet()}
        onChange={handleBetonbandChange}
      />

      <SelectUnselectExtended
        name={"Montage (incl. werkbezoek vooraf)"}
        imageUrl={"./images/Montage-conf.png"}
        description={
          "U kunt gebruik maken van onze montageservice. De montagekosten zijn inclusief voorrijkosten, een werkbezoek op locatie en het monteren van de door u gekozen producten."
        }
        isSelected={state.optionsMaterial.montage}
        onSelect={() => handleMontageToggle(true)}
        onUnselect={() => handleMontageToggle(false)}
        price={calculation.getMontagePrice()}
        selectedNames={state.optionsMaterial.montage ? "Montage actief" : ""}
      />
    </div>
  );
};

export default OptiesTab;
